// ** Default AuthConfig
import postData from 'services/postData';
import defaultAuthConfig from '../../config/auth';
// import whichRoleAccess from 'context/whichRoleAccess';
import apiEndpoints from 'constants/apiEndpoints';

const users = [
  {
    user_id: '1',
    role: 'Admin',
    user_email: 'SuperAdmin@kalyani.com',
    user_name: 'Super Admin',
    user_phone: '9876543210',
    user_status: 'Active',
    password: '7890'
  },
  {
    user_id: '2',
    role: 'Payer',
    user_email: 'Payer@kalyani.com',
    user_name: 'Payer',
    user_phone: '9111111111',
    user_status: 'Active',
    password: '7890'
  },
  {
    user_id: '3',
    role: 'Manager',
    user_email: 'Manager@kalyani.com',
    user_name: 'Manager',
    user_phone: '9222222222',
    user_status: 'Active',
    password: '7890'
  },
  {
    user_id: '4',
    role: 'Checker',
    user_email: 'Checker@kalyani.com',
    user_name: 'Approver',
    user_phone: '9333333333',
    user_status: 'Active',
    password: '7890'
  }
];

// const superAdmin = {
//   user_id: '1',
//   role: 'Admin',
//   user_email: 'SuperAdmin@kalyani.com',
//   user_name: 'Super Admin',
//   user_phone: '9876543210',
//   user_status: 'Active',
//   password: '7890'
// };

const loginUser = async (mobileNo, password) => {
  try {
    const loginData = await postData(
      { phone: mobileNo, pin: password },
      apiEndpoints.auth.login
    );
    // const getLocalUser = users.find(
    //   user => user.user_phone === mobileNo && user.password === password
    // );

    if (loginData.status) {
      const accessToken = loginData.data.user_id;

      const userData = loginData.data;

      // Role validation logic
      if (
        userData.user_type === 'Employee' &&
        userData.user_role !== 'Employee'
      ) {
        const response = {
          accessToken,
          userData: { ...loginData.data }
        };

        return [200, response];
        // Throw error if the user does not have proper access
      } else {
        return [403, { error: 'You do not have permission' }];
      }
    } else {
      return [400, { error: loginData.message || 'Login Failed' }];
    }
  } catch (error) {
    console.error('Error logging in:', error);
    return [500, { error: 'Internal Server Error' }];
  }
};

const getUserData = async config => {
  try {
    // ** Get token from header
    // @ts-expect-ignore
    const token = config.headers.Authorization;

    // ** Default response
    let response = [200, {}];

    if (!token) {
      // ** If onTokenExpiration === 'logout' then send 401 error
      if (defaultAuthConfig.onTokenExpiration === 'logout') {
        // ** 401 response will logout user from AuthContext file
        response = [401, { error: { error: 'Invalid User' } }];
      } else {
        // ** Get user id from old token
        // @ts-expect-ignore
        const userId = token;

        // ** Get user that matches id in token
        const user = users.find(u => u.id == userId);

        // ** Sign a new token
        const accessToken = token;

        // ** Set new token in localStorage
        window.localStorage.setItem(
          defaultAuthConfig.storageTokenKeyName,
          accessToken
        );
        const obj = { userData: { ...user, password: undefined } };

        // ** return 200 with user data
        response = [200, obj];
      }
    } else {
      // ** If token is valid do nothing
      // @ts-expect-ignore
      const userId = token;

      // ** Get user that matches id in token
      const userData = JSON.parse(
        JSON.stringify(users.find(u => u.id == userId))
      );
      delete userData.password;

      // ** return 200 with user data
      response = [200, { userData }];
    }

    return response;
  } catch (error) {
    console.error('Error getting user data:', error);
    return [500, { error: 'Internal Server Error' }];
  }
};

// ** Exporting functions
export { loginUser, getUserData };
